(() => {
  const configNode = document.getElementById('TrapLocalizationConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const preferenceKey = 'trap-country-language-v1';
  const defaultLanguage = country => ['DE', 'AT', 'CH'].includes(country) ? 'de' : 'en';
  const read = (storage, key) => { try { return JSON.parse(window[storage].getItem(key)); } catch { return null; } };
  const save = (storage, key, value) => { try { window[storage].setItem(key, JSON.stringify(value)); return true; } catch { return false; } };
  document.addEventListener('click', event => {
    const link = event.target.closest('localization-form a[data-value]');
    if (!link) return;
    const form = link.closest('form');
    if (!form) return;
    const countryInput = form.querySelector('input[name="country_code"]');
    if (countryInput) {
      const country = link.dataset.value;
      const language = defaultLanguage(country);
      if (!config.languages.includes(language)) return;
      let languageInput = form.querySelector('input[name="language_code"], input[name="locale_code"]');
      if (!languageInput) {
        languageInput = document.createElement('input');
        languageInput.type = 'hidden';
        languageInput.name = 'language_code';
        form.append(languageInput);
      }
      languageInput.value = language;
      save('localStorage', preferenceKey, {country, language});
    } else {
      save('localStorage', preferenceKey, {country: config.country, language: link.dataset.value});
    }
  }, true);
  const preference = read('localStorage', preferenceKey);
  const desired = preference?.country === config.country ? preference.language : defaultLanguage(config.country);
  if (desired === config.language || !config.languages.includes(desired)) return;
  const attemptKey = 'trap-locale-attempt:' + config.country + ':' + desired;
  if (read('sessionStorage', attemptKey)) return;
  const form = document.getElementById('TrapCountryLanguage');
  if (!form) return;
  if (!save('sessionStorage', attemptKey, true)) return;
  form.elements.language_code.value = desired;
  form.submit();
})();
